var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoiconamb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,0a16,16,0,1,0,7.52,30.12.64.64,0,0,0-.6-1.13,14.72,14.72,0,1,1,5.54-5.16.64.64,0,0,0,.15.9.65.65,0,0,0,.9-.16l0-.05A16,16,0,0,0,16,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,4a3.11,3.11,0,1,0,3.1,3.11h0A3.1,3.1,0,0,0,16,4ZM16,8.9a1.82,1.82,0,1,1,1.82-1.82h0A1.82,1.82,0,0,1,16,8.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.55,11.59a.64.64,0,0,0-.64.64V27.17a.64.64,0,0,0,.64.64h2a3.48,3.48,0,0,0,3.48-3.49V12.23a.63.63,0,0,0-.64-.64ZM17.8,24.32a2.19,2.19,0,0,1-2.2,2.2H14.19V12.87H17.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoiconamb);
export default __webpack_public_path__ + "static/media/infoiconamb.c6180797.svg";
export { ForwardRef as ReactComponent };